export { default } from "./navItem";
